/**
 * 用户公司信息
 * @type {{}}
 */
const initState = {
  companyRenameInfo: {},
};

const mutations = {
  updateCompanyRenameInfo(state, payload) {
    state.companyRenameInfo = payload;
  },
};

export default {
  namespaced: true,
  mutations,
  state: initState
};
